import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { createTopic, updateTopic } from '../../lib/redux/actions.jsx';
import {
  FormContainer,
  ButtonGroup,
  FormTitle,
  FormWrapper,
} from './StyledComponents';
import { Button } from '../FormStyles';
import TextInput from '../FormStyles/TextInput.jsx';
import { ColorsPicker } from './ColorsPicker.jsx';
import TopicsModal from './TopicsModal.jsx';

const TopicForm = ({ item: topic }) => {
  const { t } = useTranslation(['edit', 'shared']);
  const [name, setName] = useState('');
  const [color, setColor] = useState('');
  const [disabled, setDisabled] = useState(true);
  const maxLengthName = 30;
  const title = topic
    ? t('edit:topicForm:edit:title')
    : t('edit:topicForm:create:title');
  const label = t('edit:topicForm:label');
  const dispatch = useDispatch();

  useEffect(() => {
    if (topic) {
      setName(topic.label || topic.name);
      setColor(topic.color);
      setDisabled(false);
    }
  }, [topic]);

  useEffect(() => {
    const isDisbaled = !(name && color);
    setDisabled(isDisbaled);
  }, [name, color]);

  const topicParams = {
    name: name,
    color: color,
  };

  const submitForm = () => {
    if (topic) {
      const updateParams = {
        ...topicParams,
        id: topic.value || topic.id,
      };
      dispatch(updateTopic(updateParams));
    } else {
      dispatch(createTopic(topicParams));
    }
    TopicsModal();
  };

  const updateCharCount = e => {
    const charsLeft = maxLengthName - e.target.value.length;
    document.getElementsByClassName('character-counter')[0].innerText = t(
      'edit:topicForm:characters_count',
      {
        characters_amount: charsLeft,
      },
    );
  };

  return (
    <FormWrapper>
      <FormTitle>{title}</FormTitle>
      <FormContainer>
        <div>
          <span className="character-counter">
            {t('edit:topicForm:characters_count', { characters_amount: 25 })}
          </span>
          <TextInput
            label={label}
            placeholder={t('edit:topicForm:placeholder')}
            onChange={e => setName(e.target.value)}
            required="required"
            value={name}
            maxLength={25}
            onKeyUp={updateCharCount}
          />
        </div>
        <ColorsPicker
          color={color}
          resourceType="ribbon_tag"
          setColor={setColor}
        />
        <ButtonGroup>
          <Button variant="tertiary" onClick={() => TopicsModal()}>
            {t('shared:cancel')}
          </Button>
          <Button
            variant="containedBlue"
            ml="8px"
            type="submit"
            disabled={disabled}
            onClick={submitForm}
          >
            {t('shared:save')}
          </Button>
        </ButtonGroup>
      </FormContainer>
    </FormWrapper>
  );
};

export default TopicForm;
